
import { computed, defineComponent, PropType } from 'vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { IssueStatusTitle, IssueStatus } from 'SharedDir/constants/issue-status';
import { IconSizeType } from 'SharedComponents/ui/Icon/icon';

export default defineComponent({
  name: 'StatusBadge',
  components: { SIcon },
  props: {
    type: {
      type: String as PropType<string>,
      required: false,
      default: '',
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
    showText: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      required: false,
      type: String as PropType<IconSizeType>,
      default: 'custom-status',
    },
  },
  setup(props, { emit }) {
    const types = IssueStatus;

    const templateOptions = {
      name: 'custom:status/draft',
      tooltip: IssueStatusTitle.template,
    };
    const createdOptions = {
      name: 'custom:status/time',
      tooltip: IssueStatusTitle.created,
    };
    const inWorkOptions = {
      name: 'custom:status/planned',
      tooltip: IssueStatusTitle.in_work,
    };
    const completedOptions = {
      name: 'custom:status/completed',
      tooltip: IssueStatusTitle.completed,
    };
    const declinedOptions = {
      name: 'custom:status/canceled',
      tooltip: IssueStatusTitle.declined,
    };
    const declinedByIssuerOptions = {
      name: 'custom:status/canceled',
      tooltip: IssueStatusTitle.declined_by_issuer,
    };

    const computedProps = computed(() => {
      switch (props.type) {
        case IssueStatus.template:
          return { ...templateOptions };
          break;
        case IssueStatus.created:
          return { ...createdOptions };
          break;
        case IssueStatus.in_work:
          return { ...inWorkOptions };
          break;
        case IssueStatus.completed:
          return { ...completedOptions };
          break;
        case IssueStatus.declined:
          return { ...declinedOptions };
          break;
        case IssueStatus.declinedByIssuer:
          return { ...declinedByIssuerOptions };
          break;
        default:
          return { ...templateOptions };
      }
    });
    return { types, IssueStatusTitle, computedProps };
  },
});
